// components/AddStockButton.jsx
import React from 'react';
import useStockStore from '../../../stores/useStockStore';
import { useBrokerIntegration } from '../../../contexts/BrokerIntegrationContextCompat';

const AddStockButton = () => {
  const { stocks, setShowAddModal, setShowAllSymbolsSelectedPopup, showAddModal } = useStockStore();
  const { brokerIntegrations, hasActiveConnections, hasConnections, activeConnections } = useBrokerIntegration();

  // Debug logging removed to prevent infinite re-renders

  const handleChooseETFClick = (e) => {
    // Check if broker is connected first
    if (!isBrokerConnected) {
      e.preventDefault();
      console.log('🚫 Broker not connected - button disabled');
      return;
    }

    // Prevent default behavior and scroll to top
    e.preventDefault();
    window.scrollTo(0, 0);
    
    console.log('🎯 Choose ETF button clicked!');
    console.log('🔍 Current stocks:', stocks);
    console.log('🔍 Current showAddModal before click:', showAddModal);
    
    // A stock is considered "updated" or "active" if its type is not null
    const activeETFs = stocks.filter(stock => stock.type !== null).map(stock => stock.symbol);
    console.log('Active ETFs:', activeETFs);
    const allETFsConfigured = ['SPX', 'SPY', 'QQQ'].every(etf => activeETFs.includes(etf));
    console.log('All ETFs configured:', allETFsConfigured);

    if (allETFsConfigured) {
      console.log('🚀 Setting showAllSymbolsSelectedPopup to true');
      setShowAllSymbolsSelectedPopup(true);
    } else {
      console.log('🚀 Setting showAddModal to true');
      setShowAddModal(true);
      // Force a re-check after state update
      setTimeout(() => {
        console.log('🔍 showAddModal after setState:', useStockStore.getState().showAddModal);
      }, 100);
    }
  };

  // Check if broker is connected (be conservative and enable when any signal indicates connected)
  const isBrokerConnected = (
    !!hasActiveConnections ||
    !!hasConnections ||
    (Array.isArray(activeConnections) && activeConnections.length > 0) ||
    (Array.isArray(brokerIntegrations) && brokerIntegrations.some(b => b?.status === 'active' || b?.status === 'connected'))
  );
  
  return (
    <div>
      <button
        onClick={handleChooseETFClick}
        disabled={!isBrokerConnected}
        className={`rounded-md py-3 mb-6 flex items-center justify-center font-medium transition-colors w-full ${
          isBrokerConnected 
            ? 'bg-purple-500 text-white hover:bg-purple-400 cursor-pointer' 
            : 'bg-gray-500 text-gray-300 cursor-not-allowed opacity-50'
        }`}
        title={!isBrokerConnected ? 'Please connect a broker first' : ''}
      >
        +Choose ETF to Trade
      </button>
    </div>
  );
};

export default AddStockButton;